import { render, staticRenderFns } from "./MenuSuperior.vue?vue&type=template&id=92ac3dce"
import script from "./MenuSuperior.vue?vue&type=script&lang=js"
export * from "./MenuSuperior.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports